export default __webpack_public_path__ + "contentmodules/announce_survey_sharing_popup81914bc5e2f948bc8835f7a0a3065df7.png";